import { render, staticRenderFns } from "./CreateLostAndFound.vue?vue&type=template&id=35a94873&scoped=true"
import script from "./CreateLostAndFound.vue?vue&type=script&lang=js"
export * from "./CreateLostAndFound.vue?vue&type=script&lang=js"
import style0 from "./CreateLostAndFound.vue?vue&type=style&index=0&id=35a94873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a94873",
  null
  
)

export default component.exports